<!-- components/ReceivingFormDialog.vue -->
<template>
    <el-dialog v-model="visible" title="입고 처리" width="500px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="품명">
          <el-input :model-value="itemInfo.name" disabled />
        </el-form-item>
        <el-form-item label="색상">
          <el-input :model-value="itemInfo.color" disabled />
        </el-form-item>
        <el-form-item label="발주량">
          <el-input :model-value="itemInfo.order_quantity" disabled />
        </el-form-item>
        <el-form-item label="입고유형">
          <el-radio-group v-model="form.receiving_type">
            <el-radio value="COMPANY">회사입고</el-radio>
            <el-radio value="FACTORY_DIRECT">공장직송</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="입고창고">
          <el-select v-model="form.warehouse" :placeholder="form.receiving_type === 'FACTORY_DIRECT' ? '공장 선택' : '창고 선택'" clearable style="width: 100%">
            <el-option
              v-for="wh in filteredWarehouses"
              :key="wh.id"
              :label="`${wh.warehouse_type_display} - ${wh.name}`"
              :value="wh.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="입고일">
          <el-date-picker v-model="form.received_date" type="date" style="width: 100%" value-format="YYYY-MM-DD" />
        </el-form-item>
        <el-form-item label="입고 수량">
          <el-input-number v-model="form.quantity" :min="0" style="width: 100%" />
        </el-form-item>
        <el-form-item label="비고">
          <el-input v-model="form.remarks" type="textarea" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="visible = false">취소</el-button>
        <el-button type="primary" @click="submit">저장</el-button>
      </template>
    </el-dialog>
  </template>

  <script setup>
  import { ref, reactive, computed, onMounted } from 'vue'
  import axiosInstance from '@/api/axios'
  import { ElMessage } from 'element-plus'

  const visible = ref(false)
  const warehouses = ref([])
  const itemInfo = reactive({ name: '', color: '', order_quantity: 0 })
  const form = ref({
    material_order_item: null,
    receiving_type: 'COMPANY',
    warehouse: null,
    received_date: null,
    quantity: 0,
    remarks: ''
  })

  const filteredWarehouses = computed(() => {
    if (form.value.receiving_type === 'FACTORY_DIRECT') {
      return warehouses.value.filter(wh => wh.warehouse_type === 'FACTORY')
    }
    return warehouses.value.filter(wh => wh.warehouse_type !== 'FACTORY')
  })

  const fetchWarehouses = async () => {
    try {
      const response = await axiosInstance.get('warehouses/', { params: { is_active: true } })
      warehouses.value = response.data.results || response.data
    } catch (error) {
      console.error('Failed to fetch warehouses:', error)
    }
  }

  const open = (item) => {
    visible.value = true
    itemInfo.name = item.name || ''
    itemInfo.color = item.color || ''
    itemInfo.order_quantity = item.order_quantity || 0
    form.value = {
      material_order_item: item.id,
      receiving_type: 'COMPANY',
      warehouse: null,
      received_date: new Date().toISOString().split('T')[0],
      quantity: 0,
      remarks: ''
    }
  }
  const emit = defineEmits(['submitted'])

  const submit = async () => {
    try {
      await axiosInstance.post('/receivings/', {
        material_order_item: form.value.material_order_item,
        receiving_type: form.value.receiving_type,
        warehouse: form.value.warehouse,
        received_date: form.value.received_date,
        quantity: form.value.quantity,
        remarks: form.value.remarks,
      })
      ElMessage.success('입고 처리 완료')
      visible.value = false
      emit('submitted')
    } catch (e) {
      console.error('입고 처리 실패:', e)
      ElMessage.error('입고 처리 실패')
    }
  }

  onMounted(() => {
    fetchWarehouses()
  })

  defineExpose({ open })
  </script>
